import PolicyShell from "./legal/PolicyShell";
import { PRIVACY_POLICY } from "./legal/data/privacyPolicy";

export default function PrivacyPolicyPage() {
  return <PolicyShell data={PRIVACY_POLICY} />;
}
